import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SingleReviewComponent } from './single-review.component';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { AuthGuardService } from 'src/app/guards/auth-guard.service';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.singleReview.pageInRouting,
    data: { data: PAGES_AND_PATHS.singleReview },
    component: SingleReviewComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./single-review.module').then(m => m.SingleReviewModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SingleReviewRoutingModule { }
